import React, { useEffect } from "react";
import "./QuizSummary.scss";

const extractDivision = (cls) => {
  if (!cls) return "-";

  // case: 11 Science-A → A
  const dashMatch = cls.match(/-([A-Za-z]+)$/);
  if (dashMatch) return dashMatch[1];

  // case: 8A or 9B → A / B
  const endLetter = cls.match(/[A-Za-z]+$/);
  if (endLetter) return endLetter[0];

  return "-";
};

const removeDivision = (cls) => {
  if (!cls) return "-";

  // remove "-A" or "-B" etc
  let cleaned = cls.replace(/-[A-Za-z]+$/, "");

  // remove ending letter if format is 8A / 9B
  cleaned = cleaned.replace(/[A-Za-z]+$/, (match, offset, str) => {
    // only remove if directly attached to number (8A)
    return /\d[A-Za-z]+$/.test(str) ? "" : match;
  });

  return cleaned.trim();
};

const QuizSummaryBar = ({ data, onPreview, onEdit, onDelete }) => {
  if (!data) return null;

  return (
    <div className="quiz-summary-container">
      <div className="quiz-summary-card">
        {/* Left Side: Subject & Chapter (Compact) */}
        <div className="info-group main-identity">
          <div className="icon-wrapper">
            {/* Dynamic Icon based on subject can be added here, currently static */}
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z">
              </path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
          </div>
          <div className="text-content">
            <h3 className="subject-title" title={data?.subject}>
              {data?.subject}
            </h3>
            <span className="chapter-subtitle" title={data?.chapter[0]}>
              {data?.chapter[0]}
            </span>
          </div>
        </div>

        {/* Vertical Divider */}
        <div className="vertical-sep"></div>

        {/* Middle Side: Logistics Grid (Horizontal Row) */}
        {
 <div className="info-group logistics-data">

          <div className="data-point">
            <span className="lbl">CLASS</span>
            <span className="val">{removeDivision(data?.class)}</span>
          </div>

          <div className="data-point">
            <span className="lbl">DIV</span>
            <span className="val">{extractDivision(data?.division)}</span>
          </div>

          <div className="data-point">
            <span className="lbl">DATE</span>
            <span className="val">
              {data?.start_time
                ? new Date(data.start_time).toLocaleDateString()
                : "-"}
            </span>
          </div>

          <div className="data-point">
            <span className="lbl">TIME</span>
            <span className="val">
              {data?.start_time
                ? new Date(data.start_time).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "-"}
            </span>
          </div>

          <div className="data-point">
            <span className="lbl">Duration</span>
            <span className="val">
              {data?.duration ? `${data?.duration} min` : "-"}
            </span>
          </div>
                 <div className="data-point">
            <span className="lbl">Sets</span>
            <span className="val">
              {data?.sets?.length || 0}
            </span>
          </div>
        </div>
        
        }

        {/* Right Side: Actions */}
        <div className="info-group actions-group">
          <button
            className="btn-icon preview"
            onClick={onPreview}
            title="Preview"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
          </button>

          <button className="btn-icon edit" onClick={onEdit} title="Edit">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
          </button>

          <button className="btn-icon delete" onClick={onDelete} title="Delete">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuizSummaryBar;
